import React from 'react';
import { BarChartIcon, ChatElipsisIcon, PaperplaneIcon, PersonGroupIcon } from '@navikt/aksel-icons';
import classes from '../OrganizationUsagePage.module.css';

export interface PrimaryStatCardProps {
  label: string;
  value: string | number;
  icon?: 'people' | 'chat' | 'envelope' | 'calendar';
}

const iconMap = {
  people: PersonGroupIcon,
  chat: ChatElipsisIcon,
  envelope: PaperplaneIcon,
  calendar: BarChartIcon,
};

/**
 * Displays a primary statistic card with value, label, and optional icon
 */
export const PrimaryStatCard: React.FC<PrimaryStatCardProps> = ({ label, value, icon }) => {
  const IconComponent = icon ? iconMap[icon] : null;

  return (
    <li className={classes.statCard}>
      {IconComponent && (
        <span aria-hidden="true" className={classes.statIcon}>
          <IconComponent />
        </span>
      )}
      <span className={classes.statValue}>{value}</span>
      <span className={classes.statLabel}>{label}</span>
    </li>
  );
};
